/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bell-ring-outline': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M10 21h4a2 2 0 01-2 2 2 2 0 01-2-2m11-2v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 012-2 2 2 0 012 2v.29c2.97.88 5 3.61 5 6.71v6l2 2m-4-8a5 5 0 00-5-5 5 5 0 00-5 5v7h10v-7m2.75-7.81l-1.42 1.42A8.982 8.982 0 0121 11h2c0-2.93-1.16-5.75-3.25-7.81M1 11h2c0-2.4.96-4.7 2.67-6.39L4.25 3.19A10.96 10.96 0 001 11z"/>'
  }
})
